import { defineStore } from 'pinia';

import { GETTERMS_COOKIE_CONSENT } from '@/resources/helpers';
import { useStorage } from '@vueuse/core'

export const useConsentStore = defineStore('consent', () => {


  async function getUserCookiePreferences() {
    const getTermsLocalStorage = await useStorage(GETTERMS_COOKIE_CONSENT, null)
    const parsedGetTermsCookie = JSON.parse(getTermsLocalStorage.value)
    return parsedGetTermsCookie?.cookie_preferences ?? { Analytics: false, Marketing: false }
  }


  async function updateGTagConsent() {
    const { Analytics, Marketing } = await getUserCookiePreferences()
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'ad_storage': Marketing ? 'granted' : 'denied',
        'ad_user_data': Marketing ? 'granted' : 'denied',
        'ad_personalization': Marketing ? 'granted' : 'denied',
        'personalization_storage': Marketing ? 'granted' : 'denied',
        'analytics_storage': Analytics ? 'granted' : 'denied',

      });
    }
  }

  return {
    getUserCookiePreferences,
    updateGTagConsent,
  }

})
